<template>
  <templateLogin>
    <div class="header"></div>
    <div class="body">
      <section class="box-login">
        <div  v-if="stepPage === 1">
          <div class="title">
            <h1>{{ title }}</h1>
            <p>{{ text }}</p>
          </div>

          <div class="selection-box">
            <label
              v-for="option in options"
              :key="option.value"
              class="option"
              :class="{ selected: selectedOption === option.value }"
            >
              <input
                type="radio"
                v-model="selectedOption"
                :value="option.value"
                class="radio-input"
              />
              <span class="checkmark">
                <i  class="fa fa-check" />
              </span>
              {{ option.label }}
            </label>
          </div>

          <div class="control">
            <ui-button
              design="lg primary block"
              type="submit"
              :disabled="!selectedOption"
              :loading="loading"
              :class="status"
              @click="login"
            >
              Solicitar
            </ui-button>
          </div>
        </div>
        <div v-if="stepPage === 2">
          <div class="title">
            <h1>{{ title }}</h1>
            <p>{{ text2 }}
              <span>
                {{ selectedOption === 'email' ? 'E-mail' : 'SMS' }}
              </span>
          </p>
          </div>
          <ui-input label="Código:" size="md3" type="text" ref="token" v-model="form.token"></ui-input>
          <p v-if="codeInput.invalid" class="text-danger">{{ codeInput.message }}</p>
          <span class="try-again-text">Não recebeu o código? <span class="action" @click="stepPage = 1">Tentar novamente</span></span>
          <div class="control mt-15">
            <ui-button
              design="lg primary block"
              @click="login"
              :disabled="form.token.length < 4"
              :loading="loading"
              :class="status"
            >
              Entrar
            </ui-button>
          </div>

      </div>
      <div class="back-link">
        <span @click="backRoutes"><i class="fal fa-long-arrow-left"></i> Voltar <span v-if="stepPage === 1">para o login</span></span>
      </div>
      </section>
    </div>
  </templateLogin>
</template>

<script>
import templateLogin from '@/templates/page-login';
import { uiButton } from '@/components/ui/buttons';
import form from '@/mixins/form';
import { auth2FA } from '@/services/axios';
import { storage } from '@/services/storage';
import { mapActions } from 'vuex';
import { uiInput } from '@/components/ui/form';
import { invalid } from 'vue-moment';

export default {
  components: { templateLogin, uiButton, uiInput },

  data() {
    return {
      stepPage: 1,
      title: 'Solicitar Código - Autenticação',
      text: 'Como deseja receber o código para fazer sua autenticação?',
      text2: 'Informe o código que enviamos por',
      loading: false,
      form: {
        email: '',
        password: '',
        method: '',
        token: ''
      },
      selectedOption: '',
      status: '',
      options: [
        { label: 'Por e-mail', value: 'email' },
        { label: 'Por SMS', value: 'sms' }
      ],
      codeInput: {
        invalid: false,
        message: ''
      }
    }
  },
  watch: {
    stepPage(newVal) {
      if (newVal === 1) {
        this.form.token = ''
      }
    }
  },
  created() {
      const raw = storage.get('auth_twofactor_data')
      // Se não existir, redireciona para o login
      if (!raw) {
        this.$router.push('/login')
        return
      }

      try {
        const encoded = JSON.parse(raw)
        this.form.email = atob(encoded.email)
        this.form.password = atob(encoded.password)
      } catch (error) {
        // Se der erro ao decodificar, também redireciona
        this.$router.push('/login')
      }
  },
  methods: {
      ...mapActions('auth', ['doLogin']),
      async login(){
        this.loading = true
        if (!this.selectedOption) {
          this.$toastr.e('Selecione um meio de autenticação.')
          return;
        }
        let payload = {
          email: this.form.email,
          password: this.form.password,
          ...(this.form.token.length > 3
            ? { auth_code: this.form.token }
            : { method: this.selectedOption })
        }
        this.codeInput = {
          invalid: false,
          message: ''
        }
        try {
            const response = await this.doLogin(payload);
            if (response?.data?.message == "Código gerado com sucesso.") {
              this.stepPage = 2
              if (this.selectedOption === 'email') {
                this.$toastr.s('Um token de autenticação foi enviado para o seu e-mail.')
              }
              if (this.selectedOption === 'sms') {
                this.$toastr.s('Um token de autenticação foi enviado via SMS.')
              }
            }
            this.codeInput.invalid === false
            if (this.stepPage === 2 && this.form.token.length > 0) {
              this.$router.push({ path: '/' })
            }
        } catch (error) {
          if (error.message) {
            this.$toastr.e(error.message)
            this.codeInput = {
              invalid: true,
              message: error.message
            }
          }
        } finally {
          if (this.stepPage === 2 && this.form.token.length > 0 && this.codeInput.invalid === false) return;
          this.loading = false
        }
      },
      backRoutes() {
        if (this.stepPage === 2) {
          this.stepPage = 1
          return
        }
        if (this.stepPage === 1) {
          this.$router.push('/login')
          return
        }
      }
  }
}
</script>

<style lang="stylus" scoped>
.selection-box
  display flex
  flex-direction column
  margin 20px 0
.option
  border 1px solid #DDE5EE
  padding 18px 17px
  border-radius 5px
  cursor pointer
  display flex
  align-items center
  gap 12px
  font-weight 400
  font-family 'Roboto', sans-serif
  color #111827
  transition all 0.2s ease
  position relative
  user-select none
  margin-bottom 0px
  width 420px
  max-width 420px
  height 62px
  max-height 62px
  &:nth-child(2)
    border-top 0px
.radio-input
  display none
.checkmark
  width 20px
  height 20px
  border-radius 50%
  border 1px solid #bbb
  display flex
  align-items center
  justify-content center
  font-size 10px
  color #bbb
  font-family: FontAwesome
  content: '\f00c'
  background-color #F8F8FC
.option.selected .checkmark
  background #5AC387
  border-color #5AC387
  color white
  font-family: FontAwesome
  content: '\f00c'
.back-link
  padding-top 20px
  display flex
  align-items center
span
  color #172B46
  &:hover
    cursor pointer
  i
    font-size 12px
.try-again-text
  font-weight 400
  font-family 'Roboto', sans-serif
  color #172B46
  font-size 12px
  .action
    color #0068C1
    text-decoration underline
    cursor pointer
.text-danger
  color #ff4a66
  font-weight 500
</style>